"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectionInputPropTypes = exports.SelectionInput = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const clsx_1 = require("clsx");
const PropTypes = __importStar(require("prop-types"));
const react_1 = require("react");
const uuid_1 = require("uuid");
const eventUtils_1 = require("../common/eventUtils");
const LabelPlacements_1 = __importDefault(require("./LabelPlacements"));
const SelectionStatus_1 = __importStar(require("./SelectionStatus"));
const SelectionTypes_1 = __importStar(require("./SelectionTypes"));
const SelectionInput = (_a) => {
    var { id, type, name, label, labelPlacement, value, onClick, onChange, required, disabled, tabIndex, status, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onInit, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onValidationChanged } = _a, otherProps = __rest(_a, ["id", "type", "name", "label", "labelPlacement", "value", "onClick", "onChange", "required", "disabled", "tabIndex", "status", "onInit", "onValidationChanged"]);
    // Generate unique ID if not provided
    const memoizedId = (0, react_1.useMemo)(() => {
        return id || `${type}-${(0, uuid_1.v4)()}`;
    }, [id]);
    // Default labelPlacement on right if not provided
    labelPlacement = labelPlacement || LabelPlacements_1.default.RIGHT;
    const [isFocused, setFocus] = (0, react_1.useState)(false);
    // Use in a data attribute to provide the checked information on the root node of the component
    const [isChecked, setIsChecked] = (0, react_1.useState)((0, SelectionStatus_1.getCheckedValue)(status));
    // Used for the keyboard navigation
    // focus-visible: true when the focus was obtained by keyboard navigation (like :focus-visible pseudo class)
    const [isFocusVisible, setFocusVisible] = (0, react_1.useState)(false);
    // Accessibility keyboard navigation
    (0, react_1.useEffect)(() => {
        const keyPressHandler = (event) => {
            // Space key (https://www.w3.org/TR/uievents/#fixed-virtual-key-codes)
            // Space code (https://w3c.github.io/uievents-code/) Not supported on IE
            if (onClick &&
                !disabled &&
                isFocused &&
                (event.key === eventUtils_1.Keys.SPACE || event.key === eventUtils_1.Keys.SPACEBAR)) {
                onClick(event);
                event.preventDefault();
            }
        };
        window.addEventListener('keydown', keyPressHandler);
        return () => {
            window.removeEventListener('keydown', keyPressHandler);
        };
    }, [isFocused, onClick]);
    (0, react_1.useEffect)(() => {
        const keyUpHandler = (event) => {
            if (isFocused &&
                // Tab and Shift+Tab navigation
                (event.key === eventUtils_1.Keys.TAB ||
                    // Arrow navigation in Radio Component
                    (type === SelectionTypes_1.default.RADIO &&
                        (event.key === eventUtils_1.Keys.ARROW_LEFT ||
                            event.key === eventUtils_1.Keys.ARROW_UP ||
                            event.key === eventUtils_1.Keys.ARROW_RIGHT ||
                            event.key === eventUtils_1.Keys.ARROW_DOWN)))) {
                setFocusVisible(true);
            }
        };
        window.addEventListener('keyup', keyUpHandler);
        return () => {
            window.removeEventListener('keyup', keyUpHandler);
        };
    }, [isFocused, isFocusVisible]);
    (0, react_1.useEffect)(() => {
        setIsChecked((0, SelectionStatus_1.getCheckedValue)(status));
    }, [status]);
    // Component gets focus
    const onFocusHandler = () => {
        setFocus(true);
    };
    // Component loses focus.
    const onBlurHandler = () => {
        setFocus(false);
        setFocusVisible(false);
    };
    const onChangeHandler = (event) => {
        setIsChecked(event && event.target && (0, SelectionStatus_1.getCheckedValue)(event.target.checked));
        if (onChange) {
            // Forward the event to the onChange method defined by the user
            onChange(event);
        }
    };
    const tkClassName = `tk-${type.valueOf()}`;
    // Define 'checked' or 'defaultChecked' props depending if the component is a controlled component or not
    const checkedProps = {};
    if (status) {
        // Either 'checked' or 'defaultChecked' props must be defined but not both at the same time
        if (onChange) {
            // Controlled Component
            checkedProps['checked'] = (0, SelectionStatus_1.getCheckedValue)(status);
        }
        else {
            // Uncontrolled Component
            checkedProps['defaultChecked'] = (0, SelectionStatus_1.getCheckedValue)(status);
        }
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, clsx_1.clsx)(tkClassName, `${tkClassName}__labelPlacement--${labelPlacement}`, {
            [`${tkClassName}--focused`]: isFocused,
            [`${tkClassName}--focus-visible`]: isFocusVisible,
            [`${tkClassName}--mixed`]: status === SelectionStatus_1.default.MIXED,
            [`${tkClassName}--disabled`]: disabled,
        }), tabIndex: -1, "data-checked": isChecked, children: [(0, jsx_runtime_1.jsxs)("div", { className: `${tkClassName}__inputContainer`, children: [(0, jsx_runtime_1.jsx)("input", Object.assign({ id: memoizedId, className: `${tkClassName}__input`, type: SelectionTypes_1.SelectionInputTypes[type], name: name, value: value }, checkedProps, { disabled: disabled, onFocus: onFocusHandler, onBlur: onBlurHandler, onClick: onClick, onChange: onChangeHandler, required: required, tabIndex: tabIndex }, otherProps)), (0, jsx_runtime_1.jsx)("span", { className: (0, clsx_1.clsx)(`${tkClassName}__icon`), "aria-hidden": true })] }), (0, jsx_runtime_1.jsx)("label", { className: (0, clsx_1.clsx)(`${tkClassName}__label`, `${tkClassName}__label--${labelPlacement}`), htmlFor: memoizedId, children: label })] }));
};
exports.SelectionInput = SelectionInput;
const SelectionInputPropTypes = {
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    labelPlacement: PropTypes.oneOf(Object.values(LabelPlacements_1.default)),
    value: PropTypes.string.isRequired,
    status: PropTypes.oneOf(Object.values(SelectionStatus_1.default)),
    onClick: PropTypes.func,
    onChange: PropTypes.func,
    onInit: PropTypes.func,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    tabIndex: PropTypes.number,
};
exports.SelectionInputPropTypes = SelectionInputPropTypes;
SelectionInput.propTypes = Object.assign(Object.assign({}, SelectionInputPropTypes), { type: PropTypes.oneOf(Object.values(SelectionTypes_1.default)) });
